import Basic from '@/components/page/Basic.js'
import {  Config, AxiosWithJar } from '@/utility.js'

export default{
	extends: Basic,
	data:()=>({
		plant:{},
		store:[],
		loading: { table:true },
	}),
    methods:{
		async loadPlant(plant, station) {
			let url = Config().apiURL + "/plant?" + (plant ? "&plantno=" + plant : "") + (station ? "&stationid=" + station : "");
			await AxiosWithJar().get(url).then(result=>{
				if(result.data.length){
					this.plant = result.data[0];
				}
			})
		},

		async loadPlantSatgas(plant, station) {
			let url = Config().apiURL + "/plant/plantSatgas?" + (plant ? "&plantno=" + plant : "") + (station ? "&stationid=" + station : "");
			await AxiosWithJar().get(url).then(result=>{
				if(result.data.length){
                    //console.log('result.data: ' + JSON.stringify(result.data));
					this.plant = result.data[0];
				}
			})
		},

		async loadStoreList(plant, station) {
			let url = Config().apiURL + "/bright/storelist?" + (plant ? "&plantno=" + plant : "") + (station ? "&stationid=" + station : "");
			await AxiosWithJar().get(url).then(result=>{
				if(result.data.store.length){
					this.store = result.data.store;
				}
			})
		},

	}
}
